<!-- Copyright The Linux Foundation and each contributor to LFX. -->
<!-- SPDX-License-Identifier: MIT -->
<div class="content-wrapper">
    <h1 class="display-1 m-5">
        <button class="btn btn-link text-info d-flex align-items-center justify-content-center p-0 mb-2 font-weight-normal"
                [routerLink]="'../'"
                i18n>
            <i class="ni ni-bold-left mr-1"></i> Back
        </button>
        <ng-container *ngIf="user$ | async as user">
            {{ user.name }}
        </ng-container>
    </h1>
    <section class="row m-5">
        <div class="col p-0">
            <app-user-details-card [user]="user$ | async"></app-user-details-card>
        </div>
    </section>
    <ngb-tabset>
        <ngb-tab>
            <ng-template ngbTabTitle>
                <h4 class="display-4"
                    i18n>Roles</h4>
            </ng-template>
            <ng-template ngbTabContent>
                <ng-container *loadAfterUser>
                    <app-user-details-roles-tab [username]="username"
                                                [roles]="userRoles$ | async">
                    </app-user-details-roles-tab>
                </ng-container>
            </ng-template>
        </ngb-tab>
        <ngb-tab>
            <ng-template ngbTabTitle>
                <h4 class="display-4"
                    i18n>Groups</h4>
            </ng-template>
            <ng-template ngbTabContent>
                <app-user-details-groups-tab *ngIf="user$ | async as user"
                                             [username]="user.username"
                                             [groups]="userGroups$ | async">
                </app-user-details-groups-tab>
            </ng-template>
        </ngb-tab>
        <!-- <ngb-tab>
            <ng-template ngbTabTitle>
                <h4 class="display-4"
                    i18n>Roles v2</h4>
            </ng-template>
            <ng-template ngbTabContent>
               <app-roles-web-component [username]="username"></app-roles-web-component>
            </ng-template>
        </ngb-tab> -->
    </ngb-tabset>

    <div class="separator"></div>
</div>


// WEBPACK FOOTER //
// ./src/app/access-management/users/user-details/user-details.component.html